
import React from 'react';
import ScrollReveal from '../ui/ScrollReveal';
import { Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Simon Shuler',
      role: 'Luxury Real Estate Agent / Baton Rouge',
      content: 'Evan is very patient, and delivers exceptional quality service and media. I was thoroughly impressed with my listing photos, cinematic property tour, landing pages, and 3D walkthrough. Looking forward to future work relating to a professional website and more. Highly recommend.',
    },
    {
      id: 2,
      name: 'Edward Fultz',
      role: 'Entrepreneur, Lawyer',
      content: "We hired Evan to assist with creating and maintaining our website for The Common Nomad Podcast. Our audience and us love the website design! It's user-friendly, accessible, and stands out. Since then, Evan has been instrumental in marketing and growing our brand on an international scale. He manages our social media, website, and promotional materials. He is excellent!",
    },
    {
      id: 3,
      name: 'RPM Living / Kaylee Brock',
      role: 'Marketing Manager',
      content: 'Evan helped us shoot a lifestyle video for an apartment complex in Baton Rouge. He was very accommodating with any changes we needed to make and very responsive. Overall, we had a great experience, and the video turned out great!',
    }
  ];

  return (
    <section className="section-padding bg-astrem-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <span className="inline-block px-3 py-1 bg-astrem-gray-200 text-astrem-gray-800 rounded-full text-sm font-medium mb-4">
            Testimonials
          </span>
        </ScrollReveal>
        
        <ScrollReveal delay={100}>
          <h2 className="section-title mb-4">What Our Clients Say</h2>
        </ScrollReveal>
        
        <ScrollReveal delay={200}>
          <p className="text-lg text-astrem-gray-600 max-w-2xl mx-auto text-center mb-12">
            We take pride in creating solutions that make a real difference for our clients. Here's what they have to say about working with us.
          </p>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((testimonial, index) => (
            <ScrollReveal key={testimonial.id} delay={300 + (index * 100)}>
              <div className="bg-white p-6 md:p-8 rounded-xl shadow-sm border border-astrem-gray-200 h-full flex flex-col">
                <div className="mb-6">
                  <Quote className="h-8 w-8 text-astrem-gray-300" />
                </div>
                <p className="text-astrem-gray-700 mb-6 flex-grow">
                  "{testimonial.content}"
                </p>
                <div>
                  <h4 className="font-medium text-astrem-black">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-astrem-gray-500">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
